export default __webpack_public_path__ + "static/custom-logo-wide-8564a8dbf501ce4c1dcc09e75bc746f4.png";